import { Stack, useMantineTheme } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';

import { CanvaAdTemplatesCallout, Radios } from '@feathr/components';

import type { TCreativeType } from '../creatives.types';
import type { ICreativeTypeOption } from './AddCreativeFlow.hooks';

interface IChooseCreativeTypeContentProps {
  options: ICreativeTypeOption[];
  selectedCreativeType: TCreativeType | undefined;
  onCreativeTypeSelect: (creativeType: TCreativeType) => void;
}

function ChooseCreativeTypeContent({
  options,
  selectedCreativeType,
  onCreativeTypeSelect,
}: Readonly<IChooseCreativeTypeContentProps>): JSX.Element {
  const theme = useMantineTheme();

  function handleChange(value?: string): void {
    if (value) {
      onCreativeTypeSelect(value as TCreativeType);
    }
  }

  return (
    <Stack gap={theme.spacing['4']}>
      <CanvaAdTemplatesCallout variant={'narrow'} />
      <Radios
        dataName={'creative-type'}
        layout={'block'}
        onChange={handleChange}
        options={options}
        orientation={'vertical'}
        value={selectedCreativeType ?? ''}
      />
    </Stack>
  );
}

export default ChooseCreativeTypeContent;
